import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 常量路由（不需要权限）
const constantRoutes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/LoginPage.vue'),
        meta: { title: '登录页' }
    },
    {
        path: '/iot',
        name: 'Iot',
        component: () => import('@/views/monitoring-dashboard/DashboardRouter.vue'),
        meta: { title: '监控大屏' }
    },
    {
        path: '/dashboard',
        name: 'DashboardLive',
        component: () => import('@/views/monitoring-dashboard/DashboardLive.vue'),
        meta: { title: '监控大屏' }
    },
    {
        path: '/warning-dashboard-popup',
        name: 'WarningDashboardPopup',
        component: () => import('@/views/alarm/AlarmDashboard.vue'),
        meta: { title: '预警概况' }
    },
    {
        path: '/monitor-dashboard-popup',
        name: 'MonitorDashboardPopup',
        component: () => import('@/views/repot/MonitorDashboard.vue'),
        meta: { title: '设备分析' }
    },
    {
        path: '/energy-consumption-popup',
        name: 'EnergyConsumptionPopup',
        component: () => import('@/views/repot/EnergyConsumption.vue'),
        meta: { title: '能耗数据' }
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () => import('@/views/NotFoundPage.vue'),
        meta: { title: '404' }
    },
    // {
    //     path: '/AgentIndex',
    //     name: 'AgentIndex',
    //     component: () => import('@/views/AgentIndex.vue'),
    //     meta: {
    //         title: '我的客户',
    //         hideSidebar: true  // 添加这个标记
    //     }
    // }
]

// 需要权限的路由（首页及子页面）
const homeRoutes = {
    path: '/home',
    component: () => import('@/views/HomePage.vue'),
    meta: { requiresAuth: true },
    redirect: '/home/homeindex',
    children: [
        {
            path: 'homeindex',
            name: 'HomeIndex',
            component: () => import('@/views/HomeIndex.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '首页', permission: 'home' }
        },
        {
            path: 'AgentIndex',
            name: 'AgentIndex',
            component: () => import('@/views/customer/AgentIndex.vue'),
            meta: {
                title: '我的客户',
                hideSidebar: true  // 添加这个标记
            }
        },
        // ========== 设备管理 ==========
        {
            path: 'product/productlist',
            name: 'ProductList',
            component: () => import('@/views/product/ProductList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '产品管理', permission: 'device:product' }
        },
        {
            path: 'product/devices',
            name: 'DeviceList',
            component: () => import('@/views/product/DeviceList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '设备列表', permission: 'device:list' }
        },
        {
            path: 'product/model',
            name: 'ModelList',
            component: () => import('@/views/product/ModelList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '模型管理', permission: 'device:model' }
        },
        {
            path: 'product/pruducttype',
            name: 'ProductTypeList',
            component: () => import('@/views/product/PruductTypeList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '产品类别', permission: 'device:producttype' }
        },
        {
            path: 'product/linecategory',
            name: 'LineCategoryList',
            component: () => import('@/views/product/LineCategoryList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '线路类别', permission: 'device:producttype' }
        },
        {
            path: 'product/manufacturers',
            name: 'ManufacturersList',
            component: () => import('@/views/product/ManuFacturersList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '品牌管理', permission: 'device:manufacturer' }
        },
        {
            path: 'datamining/datamining',
            name: 'DataMining',
            component: () => import('@/views/datamining/index.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '数据挖掘', permission: 'device:datamining' },
            children: [
                {
                    path: 'dashboard',
                    component: () => import('@/views/datamining/DataMiningDashboard.vue'),
                    meta: { keepAlive: true, requiresAuth: true, title: '数据分析仪表盘', permission: 'datamining:dashboard' }
                },
                {
                    path: 'comprehensive/:deviceId',
                    component: () => import('@/views/datamining/ComprehensiveAnalysis.vue'),
                    meta: { keepAlive: false, requiresAuth: true, title: '设备综合分析', permission: 'datamining:comprehensive' }
                },
                {
                    path: 'DeviceTotal',
                    component: () => import('@/views/datamining/DeviceTotal.vue'),
                    meta: { keepAlive: true, requiresAuth: true, title: '设备总览', permission: 'datamining:total' }
                }
            ]
        },
        // ========== 监控运维 ==========
        {
            path: 'operation/schedules',
            name: 'SchedulesList',
            component: () => import('@/views/operation/SchedulesList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '定时管理', permission: 'operation:schedule' }
        },
        {
            path: 'operation/scenarios',
            name: 'ScenariosList',
            component: () => import('@/views/operation/ScenariosList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '场景联动', permission: 'operation:scenario' }
        },
        // ========== 客户管理 ==========
        {
            path: 'customer/customerIndexSet',
            name: 'CustomerIndexSet',
            component: () => import('@/views/DashboardDesigner/customerIndexSet.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '大屏模板设置', permission: 'system:basic' }
        },
        {
            path: 'customer/CustomerPage',
            name: 'CustomerPage',
            component: () => import('@/views/customer/CustomerPage.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '客户列表', permission: 'customer:list' }
        },
        {
            path: 'customer/customerAccounts',
            name: 'CustomerAccounts',
            component: () => import('@/views/customer/CustomerAccounts.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '账号列表', permission: 'customer:account' }
        },
        {
            path: 'customer/projectManagement',
            name: 'ProjectManagement',
            component: () => import('@/views/customer/ProjectManagement.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '项目管理', permission: 'customer:project' }
        },
        {
            path: 'wallet-container',
            name: 'WalletContainer',
            component: () => import('@/views/customer/wallet-container.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '充值续费', permission: 'finance:wallet' }
        },
        {
            path: 'consumption-records',
            name: 'ConsumptionRecords',
            component: () => import('@/views/customer/consumption-records.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '消费数据', permission: 'finance:consumption' }
        },
        // // ========== 7.预警信息 ==========
        {
            path: 'alarm/AlarmList',
            name: 'AlarmList',
            component: () => import('@/views/alarm/AlarmList.vue'),
            meta: { title: '报警列表', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/AlarmDashboard',
            name: 'AlarmDashboard',
            component: () => import('@/views/alarm/AlarmDashboard.vue'),
            meta: { title: '报警看板', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/AlarmCategoryConfig',
            name: 'AlarmCategoryConfig',
            component: () => import('@/views/alarm/config/AlarmCategoryConfig.vue'),
            meta: { title: '报警类别配置', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/CustomerAlarmConfig',
            name: 'CustomerAlarmConfig',
            component: () => import('@/views/alarm/config/CustomerAlarmConfig.vue'),
            meta: { title: '客户报警配置', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/AlarmTriggerTest',
            name: 'AlarmTriggerTest',
            component: () => import('@/views/alarm/test/AlarmTriggerTest.vue'),
            meta: { title: '报警触发测试', requiresAuth: true, keepAlive: false }
        },
        {
            path: 'alarm/CustomAlarmRule',
            name: 'CustomAlarmRule',
            component: () => import('@/views/alarm/CustomAlarmRule.vue'),
            meta: { title: '工单管理', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/WorkorderManagement',
            name: 'WorkorderManagement',
            component: () => import('@/views/alarm/WorkorderManagement.vue'),
            meta: { title: '工单管理', requiresAuth: true, keepAlive: true }
        },
        {
            path: 'alarm/notification-config',
            name: 'AdminNotificationConfig',
            component: () => import('@/views/alarm/AdminNotificationConfig.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '通知配置管理', permission: 'alarm:notification' }
        },
        // ========== 8.报表数据 ==========
        {
            path: 'repot/monitorDashboard',
            name: 'MonitorDashboard',
            component: () => import('@/views/repot/MonitorDashboard.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '设备分析', permission: 'report:device' }
        },
        {
            path: 'repot/energyConsumption',
            name: 'EnergyConsumption',
            component: () => import('@/views/repot/EnergyConsumption.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '能耗数据', permission: 'report:energy' }
        },
        {
            path: 'repot/OfflineAnalysis',
            name: 'OfflineAnalysis',
            component: () => import('@/views/datamining/OfflineAnalysis.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '离线分析', permission: 'report:offline' }
        },
        {
            path: 'repot/CurrentAnalysis',
            name: 'CurrentAnalysis',
            component: () => import('@/views/datamining/CurrentAnalysis.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '电流分析', permission: 'report:current' }
        },
        {
            path: 'repot/VoltageAnalysis',
            name: 'VoltageAnalysis',
            component: () => import('@/views/datamining/VoltageAnalysis.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '过压分析', permission: 'report:voltage' }
        },
        {
            path: 'repot/TemperatureAnalysis',
            name: 'TemperatureAnalysis',
            component: () => import('@/views/datamining/TemperatureAnalysis.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '温度分析', permission: 'report:temperature' }
        },
        {
            path: 'repot/EnergyList',
            name: 'EnergyList',
            component: () => import('@/views/repot/EnergyList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '能耗列表', permission: 'report:power' }
        },
        // ========== 日志数据 ==========
        {
            path: 'systemLog',
            name: 'SystemLog',
            component: () => import('@/views/system/SystemLog.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '系统日志', permission: 'log:system' }
        },
        // ========== 9.系统管理 ==========
        {
            path: 'designer',
            name: 'designer',
            component: () => import('@/views/DashboardDesigner/index.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '大屏设计', permission: 'system:basic' }
        },
        {
            path: 'dashboard/editor',
            name: 'DashboardEditor',
            component: () => import('@/views/DashboardDesigner/Editor.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '大屏编辑', permission: 'system:basic' }
        },
        {
            path: 'system/basicData',
            name: 'BasicData',
            component: () => import('@/views/system/BasicData.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '基础数据', permission: 'system:basic' }
        },
        {
            path: 'system/organizational',
            name: 'Organizational',
            component: () => import('@/views/system/OrganiZational.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '组织管理', permission: 'system:organization' }
        },
        {
            path: 'system/RateLimit',
            name: 'RateLimit',
            component: () => import('@/views/system/RateLimit.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '限流配置', permission: 'system:ratelimit' }
        },
        {
            path: 'system/Permission',
            name: 'Permission',
            component: () => import('@/views/system/Permission.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '权限管理', permission: 'system:permission' }
        },
        {
            path: 'system/Role',
            name: 'Role',
            component: () => import('@/views/system/Role.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '角色管理', permission: 'system:role' }
        },
        {
            path: 'system/PermissionAssign',
            name: 'PermissionAssign',
            component: () => import('@/views/system/PermissionAssign.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '权限分配', permission: 'system:assign' }
        },
        {
            path: 'system/scheduledTask',
            name: 'ScheduledTask',
            component: () => import('@/views/system/ScheduledTaskList.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '用户管理', permission: 'scheduled:list' }
        },
        {
            path: 'system/ModelMetricMapping',
            name: 'ModelMetricMapping',
            component: () => import('@/views/system/ModelMetricMapping.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '指标映射', permission: 'ModelMetricMapping:list' }
        },
        // ========== 10.个人中心 ==========
        {
            path: 'personal/myCustomerInfo',
            name: 'MyCustomerInfo',
            component: () => import('@/views/personal/MyCustomerInfo.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '我的企业' }
        },
        {
            path: 'personal/myProfile',
            name: 'MyProfile',
            component: () => import('@/views/personal/MyProfile.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '个人信息', permission: 'personal:profile' }
        },
        {
            path: 'personal/changePassword',
            name: 'ChangePassword',
            component: () => import('@/views/personal/ChangePassword.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '修改密码', permission: 'personal:password' }
        },
        {
            path: 'personal/notification',
            name: 'UserNotificationConfig',
            component: () => import('@/views/personal/UserNotificationConfig.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '通知设置', permission: 'personal:notification' }
        },
        // ========== OTA升级管理 ==========
        {
            path: 'ota/firmware',
            name: 'OtaFirmware',
            component: () => import('@/views/ota/OtaFirmware.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '固件管理', permission: 'ota:firmware' }
        },
        {
            path: 'ota/task',
            name: 'OtaUpgradeTask',
            component: () => import('@/views/ota/OtaUpgradeTask.vue'),
            meta: { keepAlive: true, requiresAuth: true, title: '升级任务', permission: 'ota:task' }
        },
        {
            path: 'ota/progress',
            name: 'OtaUpgradeProgress',
            component: () => import('@/views/ota/OtaUpgradeProgress.vue'),
            meta: { keepAlive: false, requiresAuth: true, title: '升级进度' }
        },
        // ========== 404 兜底 ==========
        {
            path: '*',
            redirect: '/404'
        }
    ]
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...constantRoutes, homeRoutes],
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    }
})


// 路由守卫：仅检查 token 是否存在，不每次发请求验证
// token 有效性由 request.js 的拦截器统一处理（401 自动刷新/跳转）
router.beforeEach((to, from, next) => {
    const whiteList = ['/login', '/iot', '/dashboard', '/warning-dashboard-popup', '/monitor-dashboard-popup', '/energy-consumption-popup', '/404']

    if (whiteList.includes(to.path)) {
        next()
        return
    }

    const token = localStorage.getItem('token')
    if (!token) {
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
    }

    next()
})

export default router